// =============================================================================
// SERWERY WYDRUKU W DZIALE URZĄDZEŃ — WYŁĄCZNIE PODGLĄD.
//
// Serwer wydruku jest urządzeniem organizacji tak samo jak tablet czy
// telewizor i tu jest jego miejsce w spisie sprzętu — ale jego KARTOTEKA żyje
// w organie druku (`print_agents`, migracja 186), nie w `device_licenses`.
// Powód jest twardy: CHECK na `device_class` nie dopuszcza takiej klasy, a
// limit entitlementu `mobile_devices` policzyłby serwer jako telefon.
//
// Dlatego enrolment, odwołanie tokenu i przypisania drukarek zostają
// w `/admin/printing` — dwa miejsca zapisu do jednej kartoteki to dwa źródła
// prawdy. Tutaj: co pobrać, co stoi i czy się odzywa.
// =============================================================================

import { Alert, Badge, EmptyState } from '@insolitum/ui';
import { ExternalLink, Server } from 'lucide-react';
import { Link } from 'react-router-dom';

import { OPIS_AGENTA, formatujCzasWzgledny, stanAgenta } from '../printing/status';
import { useAgents } from '../printing/usePrintingData';

export function SerweryDruku() {
  const { agenci, loading, blad } = useAgents();

  return (
    <div className="card p-4">
      <div className="flex items-center justify-between gap-3 flex-wrap mb-4">
        <h2 className="text-sm font-semibold text-aurora-text flex items-center gap-2">
          <Server className="w-4 h-4 text-aurora-brand" />
          Zarejestrowane serwery wydruku
        </h2>
        <Link to="/admin/printing?tab=agents" className="btn btn--tonal btn--sm">
          Zarządzaj w Drukowaniu
          <ExternalLink className="w-4 h-4" />
        </Link>
      </div>

      {blad && (
        <Alert variant="error" className="mb-4">
          {blad}
        </Alert>
      )}

      {loading ? (
        // Szkielet w geometrii docelowej: wycentrowana kręcąca się ikona
        // przerzucałaby układ przy każdym odświeżeniu.
        <div className="space-y-2">
          <div className="skel h-14" />
          <div className="skel h-14" />
        </div>
      ) : agenci.length === 0 ? (
        <EmptyState
          variant="card"
          icon={<Server className="w-8 h-8" />}
          title="Brak serwerów wydruku"
          description="Zainstaluj aplikację powyżej na maszynie w sieci lokalnej, a potem wygeneruj dla niej sześciocyfrowy kod parowania w dziale Drukowanie."
          action={
            <Link to="/admin/printing?tab=agents" className="btn btn--primary btn--sm">
              Przejdź do Drukowania
            </Link>
          }
        />
      ) : (
        <div className="space-y-2">
          {agenci.map((agent) => {
            const stan = stanAgenta(agent);
            const opis = OPIS_AGENTA[stan];
            return (
              <div
                key={agent.id}
                className="flex items-center justify-between gap-3 flex-wrap p-3 rounded-ids-md border border-aurora-border"
              >
                <div className="min-w-0">
                  <p className="text-sm font-medium text-aurora-text truncate">{agent.name}</p>
                  <p className="text-xs text-aurora-subtle mono truncate">
                    {agent.hostname ?? 'host nieznany'}
                    {agent.platform ? ` · ${agent.platform}` : ''}
                    {agent.app_version ? ` · v${agent.app_version}` : ''}
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-xs text-aurora-muted">
                    {formatujCzasWzgledny(agent.last_seen_at)}
                  </span>
                  <Badge variant={opis.wariant}>
                    {opis.symbol} {opis.etykieta}
                  </Badge>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
